import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';


export default function RankBadge({ rankData, onClick }) {
  const { t } = useTranslation();
  const prevXp = useRef(null);
  const [glow, setGlow] = useState(false);

  useEffect(() => {
    if (!rankData) return;
    if (prevXp.current !== null && rankData.xp > prevXp.current) {
      setGlow(true);
      const timer = setTimeout(() => setGlow(false), 1200);
      return () => clearTimeout(timer);
    }
    prevXp.current = rankData.xp;
  }, [rankData?.xp]);

  // Keep ref in sync after glow ends
  useEffect(() => {
    if (!glow && rankData) prevXp.current = rankData.xp;
  }, [glow, rankData]);

  if (!rankData) return null;

  return (
    <button className={`rank-badge${glow ? ' rank-badge-glow' : ''}`} onClick={onClick} title={t(`rank.${rankData.rank}`)}>
      <span className="rank-badge-emoji">{rankData.rank_emoji}</span>
      <span className="rank-badge-label">{t(`rank.${rankData.rank}`)}</span>
      <span className="rank-badge-xp">{rankData.xp} XP</span>
    </button>
  );
}
